import { useMemo } from "react";
import Dropdown from "./Dropdown";

/**
 * @param {object} props
 * @param {string[]} props.value
 * @param {(next: string[]) => void} props.onChange
 * @param {{ label: string, value: string }[]} props.policies
 * @param {boolean} props.disabled
 */
export default function DropDownPolicies({
  value = [],
  onChange,
  policies = [],
  disabled = false,
  width,
  maxWidth,
  sx,
  containerSx,
  inputSx,
}) {
  const options = useMemo(() => policies, [policies]);

  return (
    <Dropdown
      variant="autocomplete"
      multiple
      value={Array.isArray(value) ? value : []}
      onChange={onChange}
      options={options}
      disabled={disabled}
      placeholderKey="dropdown.policies"
      chipLimit={3}
      selectedPluralKey="dropdown.selected_plural"
      width={width}
      maxWidth={maxWidth}
      sx={sx}
      containerSx={containerSx}
      inputSx={inputSx}
    />
  );
}
